import { HttpClient, HttpEvent, HttpResponseBase } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError as _observableThrow } from "rxjs";
import {
    catchError as _observableCatch,
    mergeMap as _observableMergeMap,
} from 'rxjs/operators';
import { CreateIssueModel, QRCodeModel, RepresentativeModel } from "../models/booking-request.model";
import { ExportEformRequestModel, GetInfomationField, GetInfomationForm, RequestParams, ResultIssueInput } from '../models/forms-get.models';
import { ApiResponse, FieldOption, FormFieldInfo } from '../models/forms-response.models';
import { BaseService } from '../shared/base.service';
import { MainService } from '../shared/main.service';
import { API, HANDSHAKE } from "../utils/constants";
import { OptionsType } from '../utils/handshake.model';
import { ConfigService } from "./config.service";

@Injectable({
    providedIn: 'root'
})

export class FormsService {

    API_URL: string;
    isHandShakeFlg: boolean;

    constructor(
        private http: HttpClient,
        private mainService: MainService,
        private baseService: BaseService,
        private configSevice: ConfigService
    ) {
        this.isHandShakeFlg = this.configSevice.get(HANDSHAKE);
        this.API_URL = this.configSevice.get(API);
    }

    getFormByCode(model: GetInfomationForm): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Form/GetFormByCode';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    getFieldByTaxCode(model: GetInfomationForm): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Form/GetEformDataByCode';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    getListFieldOptions(model: GetInfomationForm): Observable<ApiResponse<FieldOption[]>> {
        let url = this.API_URL + 'Form/GetListFieldOptions';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    getFieldCreateForm(model: GetInfomationField): Observable<ApiResponse<FormFieldInfo[]>> {
        let url = this.API_URL + 'Form/GetFieldCreateForm';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    resultIssue(model: ResultIssueInput) {
        let url = this.API_URL + 'Form/ResultIssue';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    resultIssueCapture(model: ResultIssueInput) {
        let url = this.API_URL + 'Form/ResultIssueCapture';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    createIssue(model: CreateIssueModel): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Form/CustomerCreateIssue';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http.request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    callApiUrl(apiUrl: string, data: any = {}): Observable<any> {
        var prefix = "/api/services/app/";
        let url = this.API_URL + apiUrl.replace(prefix, '');
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, data, null, func, this.isHandShakeFlg)
    }

    createRepresentativeCorp(representative: RepresentativeModel): Observable<ApiResponse<any>> {
        let url_ = this.API_URL + 'Form/CreateRepresentativeCorp';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url_, representative, null, func, this.isHandShakeFlg)
    }

    getRepresentativeCorpByGuid(model: QRCodeModel): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Form/GetRepresentativeCorpByGuid';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    getQRCodeByTaxCode(model: RequestParams): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Form/GetQRCodeByTaxCode';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }

    exportEform(model: ExportEformRequestModel): Observable<HttpEvent<Blob>> {
        let url = this.API_URL + 'Form/ExportFormFile';
        url = url.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
                reportProgress: true
            }

            return this.http.request('post', endpoint, options_)
        }

        return this.baseService.handShakeAndCall<any>(url, model, null, func, this.isHandShakeFlg)
    }
}